import { render } from "./1NavigationMobile.vue?vue&type=template&id=2dc585cf&scoped=true"
import script from "./1NavigationMobile.vue?vue&type=script&lang=js"
export * from "./1NavigationMobile.vue?vue&type=script&lang=js"

import "./1NavigationMobile.vue?vue&type=style&index=0&id=2dc585cf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc585cf"]])

export default __exports__